<template>
  <div class="form-coms ui-datepicker">
    <v-menu
      v-model="showPopup"
      :disabled="disabled"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      min-height="290px"
      class="ui-datepicker-menu"
    >
      <template v-slot:activator="{ on }">
        <Input
          type="text"
          :label="label"
          right-icon="mdi-calendar"
          :value.sync="formattedValue"
          v-on="on"
          :disabled="disabled"
        />
      </template>
      <v-date-picker
        v-model="vmodel"
        @input="showPopup = false"
        :disabled="disabled"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data: () => ({
    showPopup: false,
    vmodel: null,
  }),
  props: {
    label: String,
    value: [String, Object, Date],
    disabled: Boolean,
  },
  computed: {
    formattedValue() {
      if (this.vmodel) return moment(this.vmodel).format('DD-MMM-YYYY')
      else return ''
    },
  },
  mounted() {
    if (this.value) this.vmodel = moment(this.value).format('YYYY-MM-DD')
    else this.vmodel = ''
  },
  watch: {
    value(val) {
      if (val) this.vmodel = moment(val).format('YYYY-MM-DD')
      else this.vmodel = ''
    },
    vmodel(val) {
      this.$emit('update:value', val)
    },
  },
}
</script>
<style lang="scss">
.form-inline {
  .ui-datepicker {
    .v-menu__content {
      margin-left: 160px;
    }
    .ui-input {
      width: 100%;
    }
  }
}
.ui-datepicker {
  margin-bottom: 8px;
}
.v-picker__title {
  display: none;
}
.v-date-picker-table {
  height: 222px;
}
</style>
